import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'AdditionalPropertyMetadataUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AdditionalPropertyMetadataUI/AdditionalPropertyMetadataUI.vue'),
    },
    {
      name: 'AlterColumnDetailsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AlterColumnDetailsUI/AlterColumnDetailsUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'ChangeClusterVersionLookupUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ChangeClusterVersionLookupUI/ChangeClusterVersionLookupUI.vue'),
    },
    {
      name: 'ChangeClusterVersionUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ChangeClusterVersionUI/ChangeClusterVersionUI.vue'),
    },
    {
      name: 'ChangeTenantIdentifierUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ChangeTenantIdentifierUI/ChangeTenantIdentifierUI.vue'),
    },
    {
      name: 'ClusterListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterListUI/ClusterListUI.vue'),
    },
    {
      name: 'ClusterUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterUI/ClusterUI.vue'),
    },
    {
      name: 'ClusterVersionListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterVersionListUI/ClusterVersionListUI.vue'),
    },
    {
      name: 'ClusterVersionLookupUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterVersionLookupUI/ClusterVersionLookupUI.vue'),
    },
    {
      name: 'ClusterVersionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ClusterVersionUI/ClusterVersionUI.vue'),
    },
    {
      name: 'CommandDetailsUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommandDetailsUI/CommandDetailsUI.vue'),
    },
    {
      name: 'CreateTableDetailsUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CreateTableDetailsUI/CreateTableDetailsUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CustomSubUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewEntityViewParameterUI/CustomSubUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomSubUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewPropertyUI/CustomSubUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomSubUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewStyleRuleUI/CustomSubUIViewStyleRuleUI.vue'),
    },
    {
      name: 'CustomSubUIViewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewUI/CustomSubUIViewUI.vue'),
    },
    {
      name: 'CustomUIViewCreateUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewCreateUI/CustomUIViewCreateUI.vue'),
    },
    {
      name: 'CustomUIViewDataFilterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewDataFilterUI/CustomUIViewDataFilterUI.vue'),
    },
    {
      name: 'CustomUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewEntityViewParameterUI/CustomUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomUIViewGroupsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewGroupsUI/CustomUIViewGroupsUI.vue'),
    },
    {
      name: 'CustomUIViewListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewListUI/CustomUIViewListUI.vue'),
    },
    {
      name: 'CustomUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewPropertyUI/CustomUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomUIViewSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewSortsUI/CustomUIViewSortsUI.vue'),
    },
    {
      name: 'CustomUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewStyleRuleUI/CustomUIViewStyleRuleUI.vue'),
    },
    {
      name: 'DataBaseServerListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DataBaseServerListUI/DataBaseServerListUI.vue'),
    },
    {
      name: 'DataBaseServerLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DataBaseServerLookupUI/DataBaseServerLookupUI.vue'),
    },
    {
      name: 'DataPersistenceListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DataPersistenceListUI/DataPersistenceListUI.vue'),
    },
    {
      name: 'DatabaseMigrationOptionsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseMigrationOptionsUI/DatabaseMigrationOptionsUI.vue'),
    },
    {
      name: 'DatabaseMigrationReportUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseMigrationReportUI/DatabaseMigrationReportUI.vue'),
    },
    {
      name: 'DatabaseMigrationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseMigrationUI/DatabaseMigrationUI.vue'),
    },
    {
      name: 'DatabaseServerChangeClusterVersionUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseServerChangeClusterVersionUI/DatabaseServerChangeClusterVersionUI.vue'),
    },
    {
      name: 'DatabaseServerDataPersistenceListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseServerDataPersistenceListUI/DatabaseServerDataPersistenceListUI.vue'),
    },
    {
      name: 'DatabaseServerUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatabaseServerUI/DatabaseServerUI.vue'),
    },
    {
      name: 'DeploymentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeploymentUI/DeploymentUI.vue'),
    },
    {
      name: 'EmojiListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EmojiListUI/EmojiListUI.vue'),
    },
    {
      name: 'EntityMetadataUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EntityMetadataUI/EntityMetadataUI.vue'),
    },
    {
      name: 'EnumTypeMetadataUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EnumTypeMetadataUI/EnumTypeMetadataUI.vue'),
    },
    {
      name: 'ExtendedEntityListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExtendedEntityListUI/ExtendedEntityListUI.vue'),
    },
    {
      name: 'ExtendedEntityUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExtendedEntityUI/ExtendedEntityUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'InputLanguageListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InputLanguageListUI/InputLanguageListUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'LicensingCustomerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicensingCustomerUI/LicensingCustomerUI.vue'),
    },
    {
      name: 'LicensingLicenseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicensingLicenseUI/LicensingLicenseUI.vue'),
    },
    {
      name: 'LookupMetadataUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupMetadataUI/LookupMetadataUI.vue'),
    },
    {
      name: 'MessagePublicationUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MessagePublicationUI/MessagePublicationUI.vue'),
    },
    {
      name: 'MigrationInterceptorSummaryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MigrationInterceptorSummaryUI/MigrationInterceptorSummaryUI.vue'),
    },
    {
      name: 'MigrationSummaryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MigrationSummaryUI/MigrationSummaryUI.vue'),
    },
    {
      name: 'NDAddDeployedClusterUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NDAddDeployedClusterUI/NDAddDeployedClusterUI.vue'),
    },
    {
      name: 'NDAddDeployedClusterVersionUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NDAddDeployedClusterVersionUI/NDAddDeployedClusterVersionUI.vue'),
    },
    {
      name: 'NDiagClustersByUserVerificationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NDiagClustersByUserVerificationUI/NDiagClustersByUserVerificationUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'NeosConfigureDatasetUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosConfigureDatasetUI/NeosConfigureDatasetUI.vue'),
    },
    {
      name: 'NeosConfigureWidgetUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosConfigureWidgetUI/NeosConfigureWidgetUI.vue'),
    },
    {
      name: 'NeosDashboardCreatorNew',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDashboardCreatorNew/NeosDashboardCreatorNew.vue'),
    },
    {
      name: 'NeosDashboardListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDashboardListUI/NeosDashboardListUI.vue'),
    },
    {
      name: 'NeosDashboardUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDashboardUI/NeosDashboardUI.vue'),
    },
    {
      name: 'NeosDataExportPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportPropertyUI/NeosDataExportPropertyUI.vue'),
    },
    {
      name: 'NeosDataExportSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportSortsUI/NeosDataExportSortsUI.vue'),
    },
    {
      name: 'NeosDataExportUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportUI/NeosDataExportUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingEditUI/NeosDataImportColumnMappingEditUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingListUI/NeosDataImportColumnMappingListUI.vue'),
    },
    {
      name: 'NeosDataImportSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportSettingsUI/NeosDataImportSettingsUI.vue'),
    },
    {
      name: 'NeosDataImportStagingEditUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingEditUI/NeosDataImportStagingEditUI.vue'),
    },
    {
      name: 'NeosDataImportStagingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingListUI/NeosDataImportStagingListUI.vue'),
    },
    {
      name: 'NeosDataImportStagingRowUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingRowUI/NeosDataImportStagingRowUI.vue'),
    },
    {
      name: 'NeosDataImportTargetPropertyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTargetPropertyLookupUI/NeosDataImportTargetPropertyLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateEditUI/NeosDataImportTemplateEditUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateListUI/NeosDataImportTemplateListUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateLookupUI/NeosDataImportTemplateLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTypeLookupUI/NeosDataImportTypeLookupUI.vue'),
    },
    {
      name: 'NeosDataImportUploadFileUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportUploadFileUI/NeosDataImportUploadFileUI.vue'),
    },
    {
      name: 'NeosPersonalizationEditUI',
      openMode: OpenModeType.sameFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosPersonalizationEditUI/NeosPersonalizationEditUI.vue'),
    },
    {
      name: 'NeosPersonalizationListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosPersonalizationListUI/NeosPersonalizationListUI.vue'),
    },
    {
      name: 'NeosReportTemplateSelectionUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosReportTemplateSelectionUI/NeosReportTemplateSelectionUI.vue'),
    },
    {
      name: 'NeosReportTemplateWriterDetailUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosReportTemplateWriterDetailUI/NeosReportTemplateWriterDetailUI.vue'),
    },
    {
      name: 'NeosReportTemplatesWriterListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosReportTemplatesWriterListUI/NeosReportTemplatesWriterListUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'SimulationSummaryUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SimulationSummaryUI/SimulationSummaryUI.vue'),
    },
    {
      name: 'TenantCreationUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TenantCreationUI/TenantCreationUI.vue'),
    },
    {
      name: 'TenantEditionUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TenantEditionUI/TenantEditionUI.vue'),
    },
    {
      name: 'TenantListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TenantListUI/TenantListUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
    {
      name: 'UserTenantListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserTenantListUI/UserTenantListUI.vue'),
    },
    {
      name: 'UserTenantUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserTenantUI/UserTenantUI.vue'),
    },
  ],
}
